<template>
  <footer class="main-footer">
    <div class="left">
      <div class="logo">
        <img
          src="@/assets/images/logo-rendimento.png"
          :alt="'Logotipo ' + $store.state.websiteName"
          :title="$store.state.websiteName"
        />
      </div>

      <div class="powered-by">
        <p>
          2022 © Rendimento/. Todos os direitos reservados.
        </p>
      </div>
    </div>

    <div class="right">
      <div class="social">
        <ul>
          <li> <a href="https://www.linkedin.com/company/banco-rendimento/" target="_blank"> <img src="@/assets/images/icons/LinkedIn.svg" aria-label="Linkedin" /> </a> </li>
          <li> <a href="https://www.facebook.com/bancorendimento" target="_blank"> <img src="@/assets/images/icons/Facebook.svg" aria-label="facebook" /> </a> </li>
          <li> <a href="https://www.instagram.com/bancorendimento/" target="_blank"> <img src="@/assets/images/icons/Instagram.svg" aria-label="instagram" /> </a> </li>
          <li> <a href="https://twitter.com/BancoRendimento?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank"> <img src="@/assets/images/icons/Twitter.svg" aria-label="twitter" /> </a> </li>
          <li> <a href="https://www.youtube.com/user/RendimentoVTM" target="_blank"> <img src="@/assets/images/icons/YouTube.svg" aria-label="youtube" /> </a> </li>
        </ul>
      </div>
      
      <div class="sac">
        <ul>
          <li class="nav-item">
            <a 
              href="https://www.rendimento.com.br/canal-de-denuncias/"
              target="_blank"
              class="nav-link"
            >
              Canal de Denúncias 
            </a>
          </li>

          <li class="nav-item">
            <a 
              href="https://www.rendimento.com.br/atendimento/fale-conosco/" 
              target="_blank"
              class="nav-link"
            >
              Fale conosco
            </a>
          </li>

          <li class="nav-item">
            <a 
              href="https://www.rendimento.com.br/ouvidoria/"
              target="_blank" 
              class="nav-link"
            >
              Ouvidoria
            </a>
          </li>

          <li class="nav-item">
            <a 
              href="https://www.rendimento.com.br/politica-de-privacidade/" 
              target="_blank"
              class="nav-link"
            >
              Política de privacidade
            </a>
          </li>

          <li class="nav-item">
            <a 
              href="https://www.rendimento.com.br/termos-de-uso/"
              target="_blank" 
              class="nav-link"
            >
              Termos de serviço
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "mainFooter",
  };
</script>

<style lang="scss" scoped>
  .main-footer {
    padding: 60px 70px;
    display: flex;
    justify-content: space-between;
    background: theme-color('color-1');
    @include media-breakpoint-down(md) {
      flex-wrap: wrap;
      justify-content: center;
    }
    .left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      @include media-breakpoint-down(md) {
        align-items: center;
      }
      .logo {
        width: 150px;
      }
      .powered-by {
        margin-top: 40px;
        p {
          color: white;
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      @include media-breakpoint-down(md) {
        align-items: center;
      }
      .social {
        ul {
          display: flex;
          li {
            margin-left: 10px;
          }
        }
      }
      .sac {
        margin-top: 10px;
        ul {
          display: flex;
          @include media-breakpoint-down(md) {
            flex-direction: column;
            align-items: center;
          }
        }
        a {
          color: white;
          text-decoration: none;
        }
      }
    }
  }
</style>
